"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = Modal;

var _layout = require("react-components/layout");

var _media = require("react-components/media");

var _iconButton = require("../buttons/icon-button");

var _modalBackdrop = require("./modal-backdrop");

var _typography = require("../typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _breakpoint = require("@slyk/breakpoint");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var closeIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M17.625 6.187L6 17.812m12 0L6.375 6.187\"/></svg>";

/**
 * `ModalContent` styled component.
 */
var ModalContent = (0, _styledComponents["default"])(_layout.Fill).withConfig({
  displayName: "modal__ModalContent",
  componentId: "sc-1h0pnlg-0"
})(["align-items:center;background-color:transparent;display:flex;justify-content:center;outline:none;overflow:auto;padding:16px;position:fixed;transition:visibility ", ";z-index:", ";", ""], (0, _styledTools.theme)('animations.quartTransition'), (0, _styledTools.theme)('zIndex.modal.container'), (0, _styledTools.ifProp)('isVisible', (0, _styledComponents.css)(["animation:", " ", " both;visibility:visible;"], (0, _styledTools.theme)('keyframes.modalFadeInUp'), (0, _styledTools.theme)('animations.quartTransition')), (0, _styledComponents.css)(["animation:", " ", " both;pointer-events:none;visibility:hidden;"], (0, _styledTools.theme)('keyframes.fadeOut'), (0, _styledTools.theme)('animations.defaultTransition'))));
/**
 * `ModalBody` styled component.
 */

var ModalBody = _styledComponents["default"].div.withConfig({
  displayName: "modal__ModalBody",
  componentId: "sc-1h0pnlg-1"
})(["background-color:", ";border-radius:", "px;box-shadow:", ";display:grid;grid-template-columns:minmax(auto,436px);margin:auto;padding:16px 16px 24px;", ""], (0, _styles.color)('white'), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('boxShadow.modal'), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-bottom: 56px;\n  "]))));
/**
 * `ModalBodyContent` styled component.
 */


var ModalBodyContent = _styledComponents["default"].div.withConfig({
  displayName: "modal__ModalBodyContent",
  componentId: "sc-1h0pnlg-2"
})(["", ""], _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-left: 16px;\n    padding-right: 16px;\n  "]))));
/**
 * `StyledIconButton` styled component.
 */


var StyledIconButton = (0, _styledComponents["default"])(_iconButton.IconButton).withConfig({
  displayName: "modal__StyledIconButton",
  componentId: "sc-1h0pnlg-3"
})(["margin-left:auto;"]);
/**
 * `StyledIcon` styled component.
 */

var StyledIcon = (0, _styledComponents["default"])(_media.Icon).withConfig({
  displayName: "modal__StyledIcon",
  componentId: "sc-1h0pnlg-4"
})(["display:block;margin:16px auto 0;"]);
/**
 * `Title` styled component.
 */

var Title = (0, _styledComponents["default"])(_typography.Text).attrs({
  as: 'h2',
  size: 'large'
}).withConfig({
  displayName: "modal__Title",
  componentId: "sc-1h0pnlg-5"
})(["  color:", ";font-weight:700;margin:24px 0 8px;text-align:center;"], (0, _styles.color)('secondary'));
/**
 * `Description` styled component.
 */

var Description = (0, _styledComponents["default"])(_typography.Text).attrs({
  size: 'normal'
}).withConfig({
  displayName: "modal__Description",
  componentId: "sc-1h0pnlg-6"
})(["color:", ";margin-bottom:32px;text-align:center;", ""], (0, _styles.color)('gray500'), _styles.media.min('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-bottom: 48px;\n  "]))));
/**
 * Export `Modal` component.
 */

function Modal(props) {
  var children = props.children,
      className = props.className,
      _props$closeOnPressBa = props.closeOnPressBackdrop,
      closeOnPressBackdrop = _props$closeOnPressBa === void 0 ? false : _props$closeOnPressBa,
      description = props.description,
      desktopIcon = props.desktopIcon,
      iconColor = props.iconColor,
      isVisible = props.isVisible,
      mobileIcon = props.mobileIcon,
      onFocus = props.onFocus,
      onRequestClose = props.onRequestClose,
      title = props.title;

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  var modalRef = (0, _react.useRef)();
  var isDesktop = (0, _breakpoint.useBreakpoint)('md', 'min');
  (0, _react.useEffect)(function () {
    if (isVisible && modalRef.current) {
      // $FlowFixMe
      var timeout = setTimeout(function () {
        return modalRef.current.focus();
      }, 500);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [isVisible]);
  (0, _react.useEffect)(function () {
    var documentRoot = document.getElementById('root');

    if (!documentRoot) {
      return;
    }

    if (isVisible) {
      documentRoot.setAttribute('aria-hidden', 'true');
    } else {
      documentRoot.removeAttribute('aria-hidden');
    }
  }, [isVisible]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_modalBackdrop.ModalBackdrop, {
    isClickable: closeOnPressBackdrop,
    isVisible: isVisible,
    onRequestClose: onRequestClose
  }), /*#__PURE__*/_react["default"].createElement(ModalContent, {
    "aria-hidden": !isVisible,
    "aria-modal": true,
    isVisible: isVisible,
    onFocus: onFocus,
    ref: modalRef,
    role: 'dialog',
    tabIndex: isVisible ? -1 : undefined
  }, /*#__PURE__*/_react["default"].createElement(ModalBody, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
    "aria-label": translate('common.actions.close'),
    colorTheme: 'transparent',
    icon: closeIcon,
    iconSize: '24px',
    onClick: onRequestClose,
    size: '24px'
  }), /*#__PURE__*/_react["default"].createElement(ModalBodyContent, null, desktopIcon && mobileIcon && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    "aria-hidden": true,
    color: iconColor !== null && iconColor !== void 0 ? iconColor : (0, _styles.color)('gray500'),
    icon: isDesktop ? desktopIcon : mobileIcon,
    size: isDesktop ? '72px' : '40px'
  }), title && /*#__PURE__*/_react["default"].createElement(Title, null, title), description && /*#__PURE__*/_react["default"].createElement(Description, null, description), children))));
}